import * as Immutable from "immutable";

import { Boolean } from "./types";

export class PageBanner {
    private state: Immutable.Map<string, any>;
    private imageUrls: string[] = [];
    private imageLinks: string[][] = [];
    private quotes: string[] = [];
    private stage: HTMLElement;
    private quoteStage: HTMLElement;

    constructor() {
        this.state = Immutable.Map({
            activeImage: 1,
            activeQuote: 1,
        });
        this.stage = document.querySelector("[data-banner-stage]") as HTMLElement;
        this.quoteStage = document.querySelector("[data-quotes-stage]") as HTMLElement;

        this.StartBannerSlider();
    }

    private StartBannerSlider(): void {
        this.GatherImageLinkData();
        this.GatherImageData();
        this.StartImageSlider();
        this.GatherQuoteData();
        this.StartQuotesSlider();
    }

    private GatherImageLinkData(): void {
        const imageLinkTextList: NodeListOf<HTMLElement> = document.querySelectorAll("[data-image-link]") as NodeListOf<HTMLElement>;
        const imageLinkHrefList: NodeListOf<HTMLElement> = document.querySelectorAll("[data-image-href]") as NodeListOf<HTMLElement>;

        for (let i = 0; i < imageLinkTextList.length; i++) {
            this.imageLinks.push([imageLinkTextList[i].getAttribute("data-image-link"), imageLinkHrefList[i].getAttribute("data-image-href")]);
        }
    }

    private StartQuotesSlider(): void {
        if (this.quotes.length > 0) {
            for (let i = 0; i < this.quotes.length; i++) {
                this.AppendQuoteDivToBanner(this.quotes[i]);
            }
            if (this.quotes.length > 1) {
                this.MakeQuoteActive();

                window.addEventListener("load", (event) => {
                    setInterval(() => {
                        const activeQuote: number = this.state.get("activeQuote");
                        let next: number = activeQuote + 1;
                        if (next > this.quotes.length) {
                            next = 1;
                        }
                        this.state = this.state.set("activeQuote", next);
                        this.MakeQuoteActive();
                    }, 7000);
                });
            } else {
                this.MakeQuoteActive();
            }
        }
    }

    private AppendQuoteDivToBanner(text: string): void {
        const quote: HTMLElement = document.createElement("div");
        const quoteEnd: HTMLElement = document.createElement("div");

        quote.classList.add("banner-quote");
        quote.setAttribute("data-banner-quote", "");
        quote.innerText = text;

        quoteEnd.classList.add("quote-end");
        quote.appendChild(quoteEnd);

        this.quoteStage.appendChild(quote);       
    }

    private GatherQuoteData(): void {
        const quoteList: NodeListOf<HTMLElement> = document.querySelectorAll("[data-banner-text] span") as NodeListOf<HTMLElement>;
        for (let i = 0; i < quoteList.length; i++) {
            this.quotes.push(quoteList[i].textContent.trim());
        }
    }

    private StartImageSlider(): void {
        if (this.imageUrls.length > 0) {
            // There are numbered images for the flights pages so this shouldn't be shuffled, perhaps 
            // we will have a flag to shuffle the array if we're on the homepage.

            // this.imageUrls = this.ShuffleArray(this.imageUrls);

            for (let i = 0; i < this.imageUrls.length; i++) {
                this.AppendSlideDivToBanner(i);
            }

            if (this.imageUrls.length > 1) {
                this.MakeSlideActive();

                // Defer banner scrolling at least until the document has finished loading
                window.addEventListener("load", (event) => {
                    setInterval(() => {
                        const activeSlide: number = this.state.get("activeImage");
                        let next: number = activeSlide + 1;
                        if (next > this.imageUrls.length) {
                            next = 1;
                        }
                        this.state = this.state.set("activeImage", next);
                        this.MakeSlideActive();
                    }, 7000);
                });
            } else {
                this.MakeSlideActive();
            }
        }
    }

    private MakeSlideActive(): void {
        const activeImageId: number = this.state.get("activeImage");
        const bannerSlides: NodeListOf<HTMLElement> = document.querySelectorAll("[data-banner-image]") as NodeListOf<HTMLElement>;
        const banner: HTMLElement = bannerSlides[activeImageId - 1];

        if (banner.getAttribute("data-loaded") === Boolean.FALSE.toString()) {
            banner.style.backgroundImage = `url(${this.imageUrls[activeImageId - 1]})`;
            banner.setAttribute("data-loaded", Boolean.TRUE.toString());
        }

        setTimeout(() => {
            for (let i = 0; i < bannerSlides.length; i++) {
                if (i === activeImageId - 1) {
                    bannerSlides[i].classList.add("active");
                } else {
                    bannerSlides[i].classList.remove("active");
                }
            }
        }, 300);
    }

    private MakeQuoteActive(): void {
        let activeQuote: number;
        const slideQuotes: NodeListOf<HTMLElement> = document.querySelectorAll("[data-banner-quote]") as NodeListOf<HTMLElement>;

        setTimeout(() => {
            for (let i = 0; i < slideQuotes.length; i++) {
                activeQuote = this.state.get("activeQuote");

                if (i === activeQuote - 1) {
                    slideQuotes[i].classList.add("active");
                } else {
                    slideQuotes[i].classList.remove("active");
                }
            }
        }, 300);        
    }

    private AppendSlideDivToBanner(i: number): void {
        const imageSlide = document.createElement("div");
        const imageSlideLink = document.createElement("a");
        const imageSlideJustText = document.createElement("span");

        imageSlide.classList.add("banner-image"); 
        imageSlide.setAttribute("data-banner-image", "");
        imageSlide.setAttribute("data-lazy-url", this.imageUrls[i]);
        imageSlide.setAttribute("data-loaded", Boolean.FALSE.toString());

        if (this.imageLinks.length > 0) {
            if (this.imageLinks[i][0].length > 0 && this.imageLinks[i][1].length > 0) {
                imageSlideLink.setAttribute("href", this.imageLinks[i][1]);
                imageSlideLink.innerText = this.imageLinks[i][0];
                imageSlide.appendChild(imageSlideLink);
            } else {
                imageSlideJustText.innerText = this.imageLinks[i][0];
                imageSlide.appendChild(imageSlideJustText);
            }
        }

        this.stage.appendChild(imageSlide);
    }

    private GatherImageData(): void {
        const images: NodeListOf<HTMLElement> = document.querySelectorAll("[data-image-url]") as NodeListOf<HTMLElement>;

        for (let i = 0; i < images.length; i++) {
            this.imageUrls.push(images[i].getAttribute("data-image-url"));
        }
    }

    private ShuffleArray(array: string[]): string[] {
        let currentIndex: number = array.length;
        let temporaryValue: string;
        let randomIndex: number;

        while (0 !== currentIndex) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }
}



// WEBPACK FOOTER //
// ./src/global/PageBanner.ts